var cov_1nuphi3xlt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Menu/Root.tsx",
      hash = "81fcef38fe604c2dcdc1ebd069247013e3a5d507",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Menu/Root.tsx",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 28
        },
        end: {
          line: 36,
          column: 1
        }
      },
      "1": {
        start: {
          line: 31,
          column: 17
        },
        end: {
          line: 31,
          column: 21
        }
      },
      "2": {
        start: {
          line: 35,
          column: 42
        },
        end: {
          line: 35,
          column: 52
        }
      },
      "3": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "4": {
        start: {
          line: 49,
          column: 18
        },
        end: {
          line: 66,
          column: 7
        }
      },
      "5": {
        start: {
          line: 56,
          column: 2
        },
        end: {
          line: 66,
          column: 7
        }
      },
      "6": {
        start: {
          line: 69,
          column: 17
        },
        end: {
          line: 69,
          column: 26
        }
      },
      "7": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 72,
          column: 4
        }
      },
      "8": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 24
        }
      },
      "9": {
        start: {
          line: 73,
          column: 2
        },
        end: {
          line: 73,
          column: 15
        }
      },
      "10": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 16
        }
      },
      "11": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "12": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 46
        }
      },
      "13": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 50
        }
      },
      "14": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 128,
          column: 50
        }
      },
      "15": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 129,
          column: 50
        }
      },
      "16": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 130,
          column: 65
        }
      },
      "17": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 63
        }
      },
      "18": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 132,
          column: 52
        }
      },
      "19": {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 50
        }
      },
      "20": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 48
        }
      },
      "21": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 58
        }
      },
      "22": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 136,
          column: 56
        }
      },
      "23": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 140,
          column: 5
        }
      },
      "24": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 19
        }
      },
      "25": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 143,
          column: 23
        }
      },
      "26": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 144,
          column: 25
        }
      },
      "27": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 29
        }
      },
      "28": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 22
        }
      },
      "29": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 22
        }
      },
      "30": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 65
        }
      },
      "31": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 32
        }
      },
      "32": {
        start: {
          line: 162,
          column: 42
        },
        end: {
          line: 162,
          column: 52
        }
      },
      "33": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 163,
          column: 33
        }
      },
      "34": {
        start: {
          line: 163,
          column: 18
        },
        end: {
          line: 163,
          column: 33
        }
      },
      "35": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 164,
          column: 85
        }
      },
      "36": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 23
        }
      },
      "37": {
        start: {
          line: 169,
          column: 4
        },
        end: {
          line: 169,
          column: 19
        }
      },
      "38": {
        start: {
          line: 169,
          column: 13
        },
        end: {
          line: 169,
          column: 19
        }
      },
      "39": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 64
        }
      },
      "40": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 65
        }
      },
      "41": {
        start: {
          line: 175,
          column: 4
        },
        end: {
          line: 175,
          column: 33
        }
      },
      "42": {
        start: {
          line: 176,
          column: 4
        },
        end: {
          line: 176,
          column: 35
        }
      },
      "43": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 39
        }
      },
      "44": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 178,
          column: 63
        }
      },
      "45": {
        start: {
          line: 182,
          column: 4
        },
        end: {
          line: 182,
          column: 25
        }
      },
      "46": {
        start: {
          line: 183,
          column: 4
        },
        end: {
          line: 183,
          column: 29
        }
      },
      "47": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 184,
          column: 31
        }
      },
      "48": {
        start: {
          line: 188,
          column: 23
        },
        end: {
          line: 188,
          column: 33
        }
      },
      "49": {
        start: {
          line: 189,
          column: 16
        },
        end: {
          line: 189,
          column: 89
        }
      },
      "50": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 191,
          column: 38
        }
      },
      "51": {
        start: {
          line: 191,
          column: 13
        },
        end: {
          line: 191,
          column: 38
        }
      },
      "52": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 195,
          column: 5
        }
      },
      "53": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 31
        }
      },
      "54": {
        start: {
          line: 196,
          column: 4
        },
        end: {
          line: 196,
          column: 14
        }
      },
      "55": {
        start: {
          line: 200,
          column: 21
        },
        end: {
          line: 200,
          column: 39
        }
      },
      "56": {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "57": {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 202,
          column: 38
        }
      },
      "58": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 16
        }
      },
      "59": {
        start: {
          line: 208,
          column: 26
        },
        end: {
          line: 208,
          column: 36
        }
      },
      "60": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 209,
          column: 39
        }
      },
      "61": {
        start: {
          line: 209,
          column: 27
        },
        end: {
          line: 209,
          column: 39
        }
      },
      "62": {
        start: {
          line: 210,
          column: 4
        },
        end: {
          line: 210,
          column: 37
        }
      },
      "63": {
        start: {
          line: 214,
          column: 21
        },
        end: {
          line: 214,
          column: 31
        }
      },
      "64": {
        start: {
          line: 215,
          column: 4
        },
        end: {
          line: 215,
          column: 23
        }
      },
      "65": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 21
        }
      },
      "66": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 217,
          column: 23
        }
      },
      "67": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 31
        }
      },
      "68": {
        start: {
          line: 218,
          column: 25
        },
        end: {
          line: 218,
          column: 31
        }
      },
      "69": {
        start: {
          line: 219,
          column: 23
        },
        end: {
          line: 219,
          column: 111
        }
      },
      "70": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 82
        }
      },
      "71": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 227,
          column: 6
        }
      },
      "72": {
        start: {
          line: 225,
          column: 21
        },
        end: {
          line: 225,
          column: 35
        }
      },
      "73": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 226,
          column: 52
        }
      },
      "74": {
        start: {
          line: 231,
          column: 29
        },
        end: {
          line: 231,
          column: 39
        }
      },
      "75": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 235,
          column: 6
        }
      },
      "76": {
        start: {
          line: 233,
          column: 21
        },
        end: {
          line: 233,
          column: 39
        }
      },
      "77": {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 234,
          column: 28
        }
      },
      "78": {
        start: {
          line: 236,
          column: 20
        },
        end: {
          line: 236,
          column: 112
        }
      },
      "79": {
        start: {
          line: 236,
          column: 52
        },
        end: {
          line: 236,
          column: 100
        }
      },
      "80": {
        start: {
          line: 236,
          column: 73
        },
        end: {
          line: 236,
          column: 99
        }
      },
      "81": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 239,
          column: 5
        }
      },
      "82": {
        start: {
          line: 238,
          column: 6
        },
        end: {
          line: 238,
          column: 32
        }
      },
      "83": {
        start: {
          line: 243,
          column: 4
        },
        end: {
          line: 246,
          column: 6
        }
      },
      "84": {
        start: {
          line: 244,
          column: 21
        },
        end: {
          line: 244,
          column: 41
        }
      },
      "85": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 30
        }
      },
      "86": {
        start: {
          line: 250,
          column: 24
        },
        end: {
          line: 254,
          column: 6
        }
      },
      "87": {
        start: {
          line: 251,
          column: 6
        },
        end: {
          line: 253,
          column: 29
        }
      },
      "88": {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 252,
          column: 27
        }
      },
      "89": {
        start: {
          line: 253,
          column: 13
        },
        end: {
          line: 253,
          column: 29
        }
      },
      "90": {
        start: {
          line: 255,
          column: 4
        },
        end: {
          line: 255,
          column: 26
        }
      },
      "91": {
        start: {
          line: 256,
          column: 17
        },
        end: {
          line: 256,
          column: 47
        }
      },
      "92": {
        start: {
          line: 257,
          column: 50
        },
        end: {
          line: 257,
          column: 60
        }
      },
      "93": {
        start: {
          line: 258,
          column: 4
        },
        end: {
          line: 261,
          column: 5
        }
      },
      "94": {
        start: {
          line: 259,
          column: 6
        },
        end: {
          line: 259,
          column: 24
        }
      },
      "95": {
        start: {
          line: 260,
          column: 6
        },
        end: {
          line: 260,
          column: 12
        }
      },
      "96": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 70
        }
      },
      "97": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 263,
          column: 22
        }
      },
      "98": {
        start: {
          line: 267,
          column: 20
        },
        end: {
          line: 267,
          column: 54
        }
      },
      "99": {
        start: {
          line: 268,
          column: 17
        },
        end: {
          line: 268,
          column: 64
        }
      },
      "100": {
        start: {
          line: 269,
          column: 19
        },
        end: {
          line: 269,
          column: 68
        }
      },
      "101": {
        start: {
          line: 270,
          column: 4
        },
        end: {
          line: 270,
          column: 58
        }
      },
      "102": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 271,
          column: 46
        }
      },
      "103": {
        start: {
          line: 275,
          column: 23
        },
        end: {
          line: 275,
          column: 61
        }
      },
      "104": {
        start: {
          line: 276,
          column: 25
        },
        end: {
          line: 276,
          column: 72
        }
      },
      "105": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 58
        }
      },
      "106": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 37
        }
      },
      "107": {
        start: {
          line: 291,
          column: 21
        },
        end: {
          line: 291,
          column: 31
        }
      },
      "108": {
        start: {
          line: 292,
          column: 36
        },
        end: {
          line: 292,
          column: 51
        }
      },
      "109": {
        start: {
          line: 293,
          column: 18
        },
        end: {
          line: 293,
          column: 35
        }
      },
      "110": {
        start: {
          line: 294,
          column: 17
        },
        end: {
          line: 294,
          column: 60
        }
      },
      "111": {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 296,
          column: 62
        }
      },
      "112": {
        start: {
          line: 297,
          column: 20
        },
        end: {
          line: 297,
          column: 55
        }
      },
      "113": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 66
        }
      },
      "114": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 22
        }
      },
      "115": {
        start: {
          line: 304,
          column: 24
        },
        end: {
          line: 304,
          column: 34
        }
      },
      "116": {
        start: {
          line: 305,
          column: 4
        },
        end: {
          line: 305,
          column: 36
        }
      },
      "117": {
        start: {
          line: 306,
          column: 4
        },
        end: {
          line: 306,
          column: 30
        }
      },
      "118": {
        start: {
          line: 306,
          column: 17
        },
        end: {
          line: 306,
          column: 30
        }
      },
      "119": {
        start: {
          line: 310,
          column: 27
        },
        end: {
          line: 310,
          column: 37
        }
      },
      "120": {
        start: {
          line: 311,
          column: 4
        },
        end: {
          line: 311,
          column: 89
        }
      },
      "121": {
        start: {
          line: 311,
          column: 40
        },
        end: {
          line: 311,
          column: 89
        }
      },
      "122": {
        start: {
          line: 312,
          column: 4
        },
        end: {
          line: 312,
          column: 72
        }
      },
      "123": {
        start: {
          line: 312,
          column: 42
        },
        end: {
          line: 312,
          column: 72
        }
      },
      "124": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 15
        }
      },
      "125": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 317,
          column: 57
        }
      },
      "126": {
        start: {
          line: 317,
          column: 46
        },
        end: {
          line: 317,
          column: 57
        }
      },
      "127": {
        start: {
          line: 319,
          column: 21
        },
        end: {
          line: 319,
          column: 31
        }
      },
      "128": {
        start: {
          line: 320,
          column: 22
        },
        end: {
          line: 320,
          column: 41
        }
      },
      "129": {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 322,
          column: 31
        }
      },
      "130": {
        start: {
          line: 322,
          column: 20
        },
        end: {
          line: 322,
          column: 31
        }
      },
      "131": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 339,
          column: 5
        }
      },
      "132": {
        start: {
          line: 325,
          column: 24
        },
        end: {
          line: 325,
          column: 62
        }
      },
      "133": {
        start: {
          line: 326,
          column: 26
        },
        end: {
          line: 326,
          column: 72
        }
      },
      "134": {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 43
        }
      },
      "135": {
        start: {
          line: 327,
          column: 32
        },
        end: {
          line: 327,
          column: 43
        }
      },
      "136": {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 338,
          column: 7
        }
      },
      "137": {
        start: {
          line: 341,
          column: 19
        },
        end: {
          line: 341,
          column: 64
        }
      },
      "138": {
        start: {
          line: 342,
          column: 25
        },
        end: {
          line: 342,
          column: 72
        }
      },
      "139": {
        start: {
          line: 343,
          column: 4
        },
        end: {
          line: 343,
          column: 42
        }
      },
      "140": {
        start: {
          line: 343,
          column: 31
        },
        end: {
          line: 343,
          column: 42
        }
      },
      "141": {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 354,
          column: 5
        }
      },
      "142": {
        start: {
          line: 374,
          column: 8
        },
        end: {
          line: 374,
          column: 18
        }
      },
      "143": {
        start: {
          line: 375,
          column: 23
        },
        end: {
          line: 375,
          column: 53
        }
      },
      "144": {
        start: {
          line: 376,
          column: 23
        },
        end: {
          line: 376,
          column: 99
        }
      },
      "145": {
        start: {
          line: 378,
          column: 16
        },
        end: {
          line: 378,
          column: 23
        }
      },
      "146": {
        start: {
          line: 380,
          column: 22
        },
        end: {
          line: 390,
          column: 5
        }
      },
      "147": {
        start: {
          line: 392,
          column: 43
        },
        end: {
          line: 392,
          column: 45
        }
      },
      "148": {
        start: {
          line: 393,
          column: 4
        },
        end: {
          line: 393,
          column: 84
        }
      },
      "149": {
        start: {
          line: 393,
          column: 55
        },
        end: {
          line: 393,
          column: 84
        }
      },
      "150": {
        start: {
          line: 395,
          column: 21
        },
        end: {
          line: 395,
          column: 22
        }
      },
      "151": {
        start: {
          line: 396,
          column: 18
        },
        end: {
          line: 396,
          column: 19
        }
      },
      "152": {
        start: {
          line: 397,
          column: 4
        },
        end: {
          line: 401,
          column: 5
        }
      },
      "153": {
        start: {
          line: 398,
          column: 19
        },
        end: {
          line: 398,
          column: 57
        }
      },
      "154": {
        start: {
          line: 399,
          column: 6
        },
        end: {
          line: 399,
          column: 30
        }
      },
      "155": {
        start: {
          line: 400,
          column: 6
        },
        end: {
          line: 400,
          column: 24
        }
      },
      "156": {
        start: {
          line: 403,
          column: 42
        },
        end: {
          line: 403,
          column: 54
        }
      },
      "157": {
        start: {
          line: 404,
          column: 4
        },
        end: {
          line: 404,
          column: 54
        }
      },
      "158": {
        start: {
          line: 404,
          column: 30
        },
        end: {
          line: 404,
          column: 54
        }
      },
      "159": {
        start: {
          line: 406,
          column: 4
        },
        end: {
          line: 438,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 31,
            column: 12
          }
        },
        loc: {
          start: {
            line: 31,
            column: 17
          },
          end: {
            line: 31,
            column: 21
          }
        },
        line: 31
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 12
          },
          end: {
            line: 35,
            column: 13
          }
        },
        loc: {
          start: {
            line: 35,
            column: 42
          },
          end: {
            line: 35,
            column: 52
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 49,
            column: 18
          },
          end: {
            line: 49,
            column: 19
          }
        },
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 66,
            column: 7
          }
        },
        line: 56
      },
      "3": {
        name: "keyToMap",
        decl: {
          start: {
            line: 68,
            column: 9
          },
          end: {
            line: 68,
            column: 17
          }
        },
        loc: {
          start: {
            line: 68,
            column: 51
          },
          end: {
            line: 74,
            column: 1
          }
        },
        line: 68
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 70,
            column: 15
          },
          end: {
            line: 70,
            column: 16
          }
        },
        loc: {
          start: {
            line: 70,
            column: 20
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 38
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 116
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        loc: {
          start: {
            line: 147,
            column: 22
          },
          end: {
            line: 150,
            column: 3
          }
        },
        line: 147
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 152,
            column: 2
          },
          end: {
            line: 152,
            column: 3
          }
        },
        loc: {
          start: {
            line: 152,
            column: 23
          },
          end: {
            line: 154,
            column: 3
          }
        },
        line: 152
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 156,
            column: 2
          },
          end: {
            line: 156,
            column: 3
          }
        },
        loc: {
          start: {
            line: 156,
            column: 25
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 156
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 161,
            column: 2
          },
          end: {
            line: 161,
            column: 3
          }
        },
        loc: {
          start: {
            line: 161,
            column: 16
          },
          end: {
            line: 165,
            column: 3
          }
        },
        line: 161
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 167,
            column: 2
          },
          end: {
            line: 167,
            column: 3
          }
        },
        loc: {
          start: {
            line: 167,
            column: 38
          },
          end: {
            line: 172,
            column: 3
          }
        },
        line: 167
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 174,
            column: 2
          },
          end: {
            line: 174,
            column: 3
          }
        },
        loc: {
          start: {
            line: 174,
            column: 99
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 174
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 181,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        },
        loc: {
          start: {
            line: 181,
            column: 25
          },
          end: {
            line: 185,
            column: 3
          }
        },
        line: 181
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 187,
            column: 2
          },
          end: {
            line: 187,
            column: 3
          }
        },
        loc: {
          start: {
            line: 187,
            column: 35
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 187
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 199,
            column: 3
          }
        },
        loc: {
          start: {
            line: 199,
            column: 24
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 199
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 207,
            column: 2
          },
          end: {
            line: 207,
            column: 3
          }
        },
        loc: {
          start: {
            line: 207,
            column: 26
          },
          end: {
            line: 211,
            column: 3
          }
        },
        line: 207
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 213,
            column: 2
          },
          end: {
            line: 213,
            column: 3
          }
        },
        loc: {
          start: {
            line: 213,
            column: 16
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 213
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        loc: {
          start: {
            line: 223,
            column: 17
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 223
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 224,
            column: 36
          },
          end: {
            line: 224,
            column: 37
          }
        },
        loc: {
          start: {
            line: 224,
            column: 42
          },
          end: {
            line: 227,
            column: 5
          }
        },
        line: 224
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 230,
            column: 2
          },
          end: {
            line: 230,
            column: 3
          }
        },
        loc: {
          start: {
            line: 230,
            column: 15
          },
          end: {
            line: 240,
            column: 3
          }
        },
        line: 230
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 232,
            column: 40
          },
          end: {
            line: 232,
            column: 41
          }
        },
        loc: {
          start: {
            line: 232,
            column: 46
          },
          end: {
            line: 235,
            column: 5
          }
        },
        line: 232
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 236,
            column: 47
          },
          end: {
            line: 236,
            column: 48
          }
        },
        loc: {
          start: {
            line: 236,
            column: 52
          },
          end: {
            line: 236,
            column: 100
          }
        },
        line: 236
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 236,
            column: 63
          },
          end: {
            line: 236,
            column: 64
          }
        },
        loc: {
          start: {
            line: 236,
            column: 73
          },
          end: {
            line: 236,
            column: 99
          }
        },
        line: 236
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 242,
            column: 2
          },
          end: {
            line: 242,
            column: 3
          }
        },
        loc: {
          start: {
            line: 242,
            column: 17
          },
          end: {
            line: 247,
            column: 3
          }
        },
        line: 242
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 243,
            column: 42
          },
          end: {
            line: 243,
            column: 43
          }
        },
        loc: {
          start: {
            line: 243,
            column: 48
          },
          end: {
            line: 246,
            column: 5
          }
        },
        line: 243
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 249,
            column: 2
          },
          end: {
            line: 249,
            column: 3
          }
        },
        loc: {
          start: {
            line: 249,
            column: 44
          },
          end: {
            line: 264,
            column: 3
          }
        },
        line: 249
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 250,
            column: 60
          },
          end: {
            line: 250,
            column: 61
          }
        },
        loc: {
          start: {
            line: 250,
            column: 69
          },
          end: {
            line: 254,
            column: 5
          }
        },
        line: 250
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 257,
            column: 27
          },
          end: {
            line: 257,
            column: 28
          }
        },
        loc: {
          start: {
            line: 257,
            column: 33
          },
          end: {
            line: 257,
            column: 35
          }
        },
        line: 257
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 266,
            column: 2
          },
          end: {
            line: 266,
            column: 3
          }
        },
        loc: {
          start: {
            line: 266,
            column: 46
          },
          end: {
            line: 272,
            column: 3
          }
        },
        line: 266
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 274,
            column: 2
          },
          end: {
            line: 274,
            column: 3
          }
        },
        loc: {
          start: {
            line: 274,
            column: 28
          },
          end: {
            line: 279,
            column: 3
          }
        },
        line: 274
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 281,
            column: 2
          },
          end: {
            line: 281,
            column: 3
          }
        },
        loc: {
          start: {
            line: 289,
            column: 4
          },
          end: {
            line: 301,
            column: 3
          }
        },
        line: 289
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 303,
            column: 2
          },
          end: {
            line: 303,
            column: 3
          }
        },
        loc: {
          start: {
            line: 303,
            column: 35
          },
          end: {
            line: 307,
            column: 3
          }
        },
        line: 303
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 309,
            column: 2
          },
          end: {
            line: 309,
            column: 3
          }
        },
        loc: {
          start: {
            line: 309,
            column: 37
          },
          end: {
            line: 314,
            column: 3
          }
        },
        line: 309
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 316,
            column: 2
          },
          end: {
            line: 316,
            column: 3
          }
        },
        loc: {
          start: {
            line: 316,
            column: 20
          },
          end: {
            line: 355,
            column: 3
          }
        },
        line: 316
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 357,
            column: 2
          },
          end: {
            line: 357,
            column: 3
          }
        },
        loc: {
          start: {
            line: 357,
            column: 11
          },
          end: {
            line: 439,
            column: 3
          }
        },
        line: 357
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 66,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 66,
            column: 7
          }
        }],
        line: 56
      },
      "1": {
        loc: {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 68,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 33
          },
          end: {
            line: 68,
            column: 35
          }
        }],
        line: 68
      },
      "2": {
        loc: {
          start: {
            line: 68,
            column: 37
          },
          end: {
            line: 68,
            column: 49
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 45
          },
          end: {
            line: 68,
            column: 49
          }
        }],
        line: 68
      },
      "3": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 33
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 33
          }
        }],
        line: 163
      },
      "4": {
        loc: {
          start: {
            line: 164,
            column: 11
          },
          end: {
            line: 164,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 29
          },
          end: {
            line: 164,
            column: 67
          }
        }, {
          start: {
            line: 164,
            column: 70
          },
          end: {
            line: 164,
            column: 85
          }
        }],
        line: 164
      },
      "5": {
        loc: {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 19
          }
        }, {
          start: {
            line: 169,
            column: 4
          },
          end: {
            line: 169,
            column: 19
          }
        }],
        line: 169
      },
      "6": {
        loc: {
          start: {
            line: 189,
            column: 16
          },
          end: {
            line: 189,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 47
          },
          end: {
            line: 189,
            column: 59
          }
        }, {
          start: {
            line: 189,
            column: 62
          },
          end: {
            line: 189,
            column: 89
          }
        }],
        line: 189
      },
      "7": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 38
          }
        }, {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 191,
            column: 38
          }
        }],
        line: 191
      },
      "8": {
        loc: {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }, {
          start: {
            line: 192,
            column: 4
          },
          end: {
            line: 195,
            column: 5
          }
        }],
        line: 192
      },
      "9": {
        loc: {
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 192,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 8
          },
          end: {
            line: 192,
            column: 12
          }
        }, {
          start: {
            line: 192,
            column: 16
          },
          end: {
            line: 192,
            column: 43
          }
        }],
        line: 192
      },
      "10": {
        loc: {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        }, {
          start: {
            line: 201,
            column: 4
          },
          end: {
            line: 203,
            column: 5
          }
        }],
        line: 201
      },
      "11": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 39
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 39
          }
        }],
        line: 209
      },
      "12": {
        loc: {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 209,
            column: 18
          }
        }, {
          start: {
            line: 209,
            column: 22
          },
          end: {
            line: 209,
            column: 25
          }
        }],
        line: 209
      },
      "13": {
        loc: {
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 218,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 218,
            column: 31
          }
        }, {
          start: {
            line: 218,
            column: 4
          },
          end: {
            line: 218,
            column: 31
          }
        }],
        line: 218
      },
      "14": {
        loc: {
          start: {
            line: 219,
            column: 23
          },
          end: {
            line: 219,
            column: 111
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 219,
            column: 43
          },
          end: {
            line: 219,
            column: 74
          }
        }, {
          start: {
            line: 219,
            column: 77
          },
          end: {
            line: 219,
            column: 111
          }
        }],
        line: 219
      },
      "15": {
        loc: {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        }, {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        }],
        line: 237
      },
      "16": {
        loc: {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 29
          }
        }, {
          start: {
            line: 251,
            column: 6
          },
          end: {
            line: 253,
            column: 29
          }
        }],
        line: 251
      },
      "17": {
        loc: {
          start: {
            line: 257,
            column: 12
          },
          end: {
            line: 257,
            column: 35
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 257,
            column: 27
          },
          end: {
            line: 257,
            column: 35
          }
        }],
        line: 257
      },
      "18": {
        loc: {
          start: {
            line: 258,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 258,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        }, {
          start: {
            line: 258,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        }],
        line: 258
      },
      "19": {
        loc: {
          start: {
            line: 267,
            column: 20
          },
          end: {
            line: 267,
            column: 54
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 267,
            column: 36
          },
          end: {
            line: 267,
            column: 44
          }
        }, {
          start: {
            line: 267,
            column: 47
          },
          end: {
            line: 267,
            column: 54
          }
        }],
        line: 267
      },
      "20": {
        loc: {
          start: {
            line: 298,
            column: 38
          },
          end: {
            line: 298,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 298,
            column: 52
          },
          end: {
            line: 298,
            column: 53
          }
        }, {
          start: {
            line: 298,
            column: 56
          },
          end: {
            line: 298,
            column: 63
          }
        }],
        line: 298
      },
      "21": {
        loc: {
          start: {
            line: 306,
            column: 4
          },
          end: {
            line: 306,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 306,
            column: 4
          },
          end: {
            line: 306,
            column: 30
          }
        }, {
          start: {
            line: 306,
            column: 4
          },
          end: {
            line: 306,
            column: 30
          }
        }],
        line: 306
      },
      "22": {
        loc: {
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 311,
            column: 89
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 311,
            column: 89
          }
        }, {
          start: {
            line: 311,
            column: 4
          },
          end: {
            line: 311,
            column: 89
          }
        }],
        line: 311
      },
      "23": {
        loc: {
          start: {
            line: 312,
            column: 4
          },
          end: {
            line: 312,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 312,
            column: 4
          },
          end: {
            line: 312,
            column: 72
          }
        }, {
          start: {
            line: 312,
            column: 4
          },
          end: {
            line: 312,
            column: 72
          }
        }],
        line: 312
      },
      "24": {
        loc: {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 57
          }
        }, {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 57
          }
        }],
        line: 317
      },
      "25": {
        loc: {
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 317,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 317,
            column: 25
          }
        }, {
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 44
          }
        }],
        line: 317
      },
      "26": {
        loc: {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 322,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 322,
            column: 31
          }
        }, {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 322,
            column: 31
          }
        }],
        line: 322
      },
      "27": {
        loc: {
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 339,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 339,
            column: 5
          }
        }, {
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 339,
            column: 5
          }
        }],
        line: 324
      },
      "28": {
        loc: {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 43
          }
        }, {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 43
          }
        }],
        line: 327
      },
      "29": {
        loc: {
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 343,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 343,
            column: 42
          }
        }, {
          start: {
            line: 343,
            column: 4
          },
          end: {
            line: 343,
            column: 42
          }
        }],
        line: 343
      },
      "30": {
        loc: {
          start: {
            line: 359,
            column: 6
          },
          end: {
            line: 359,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 359,
            column: 13
          },
          end: {
            line: 359,
            column: 30
          }
        }],
        line: 359
      },
      "31": {
        loc: {
          start: {
            line: 376,
            column: 23
          },
          end: {
            line: 376,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 376,
            column: 26
          },
          end: {
            line: 376,
            column: 31
          }
        }, {
          start: {
            line: 376,
            column: 35
          },
          end: {
            line: 376,
            column: 47
          }
        }, {
          start: {
            line: 376,
            column: 52
          },
          end: {
            line: 376,
            column: 58
          }
        }, {
          start: {
            line: 376,
            column: 63
          },
          end: {
            line: 376,
            column: 73
          }
        }, {
          start: {
            line: 376,
            column: 78
          },
          end: {
            line: 376,
            column: 99
          }
        }],
        line: 376
      },
      "32": {
        loc: {
          start: {
            line: 383,
            column: 8
          },
          end: {
            line: 383,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 383,
            column: 21
          },
          end: {
            line: 383,
            column: 31
          }
        }, {
          start: {
            line: 383,
            column: 34
          },
          end: {
            line: 383,
            column: 38
          }
        }],
        line: 383
      },
      "33": {
        loc: {
          start: {
            line: 384,
            column: 8
          },
          end: {
            line: 384,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 384,
            column: 8
          },
          end: {
            line: 384,
            column: 24
          }
        }, {
          start: {
            line: 384,
            column: 28
          },
          end: {
            line: 384,
            column: 34
          }
        }],
        line: 384
      },
      "34": {
        loc: {
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 385,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 385,
            column: 8
          },
          end: {
            line: 385,
            column: 18
          }
        }, {
          start: {
            line: 385,
            column: 22
          },
          end: {
            line: 385,
            column: 30
          }
        }],
        line: 385
      },
      "35": {
        loc: {
          start: {
            line: 386,
            column: 8
          },
          end: {
            line: 386,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 386,
            column: 8
          },
          end: {
            line: 386,
            column: 26
          }
        }, {
          start: {
            line: 386,
            column: 30
          },
          end: {
            line: 386,
            column: 40
          }
        }],
        line: 386
      },
      "36": {
        loc: {
          start: {
            line: 387,
            column: 8
          },
          end: {
            line: 387,
            column: 20
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 8
          },
          end: {
            line: 387,
            column: 11
          }
        }, {
          start: {
            line: 387,
            column: 15
          },
          end: {
            line: 387,
            column: 20
          }
        }],
        line: 387
      },
      "37": {
        loc: {
          start: {
            line: 393,
            column: 4
          },
          end: {
            line: 393,
            column: 84
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 393,
            column: 4
          },
          end: {
            line: 393,
            column: 84
          }
        }, {
          start: {
            line: 393,
            column: 4
          },
          end: {
            line: 393,
            column: 84
          }
        }],
        line: 393
      },
      "38": {
        loc: {
          start: {
            line: 393,
            column: 8
          },
          end: {
            line: 393,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 393,
            column: 8
          },
          end: {
            line: 393,
            column: 13
          }
        }, {
          start: {
            line: 393,
            column: 17
          },
          end: {
            line: 393,
            column: 28
          }
        }, {
          start: {
            line: 393,
            column: 32
          },
          end: {
            line: 393,
            column: 53
          }
        }],
        line: 393
      },
      "39": {
        loc: {
          start: {
            line: 397,
            column: 4
          },
          end: {
            line: 401,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 397,
            column: 4
          },
          end: {
            line: 401,
            column: 5
          }
        }, {
          start: {
            line: 397,
            column: 4
          },
          end: {
            line: 401,
            column: 5
          }
        }],
        line: 397
      },
      "40": {
        loc: {
          start: {
            line: 404,
            column: 4
          },
          end: {
            line: 404,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 404,
            column: 4
          },
          end: {
            line: 404,
            column: 54
          }
        }, {
          start: {
            line: 404,
            column: 4
          },
          end: {
            line: 404,
            column: 54
          }
        }],
        line: 404
      },
      "41": {
        loc: {
          start: {
            line: 436,
            column: 9
          },
          end: {
            line: 436,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 436,
            column: 9
          },
          end: {
            line: 436,
            column: 19
          }
        }, {
          start: {
            line: 436,
            column: 23
          },
          end: {
            line: 436,
            column: 45
          }
        }],
        line: 436
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    b: {
      "0": [0, 0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0],
      "31": [0, 0, 0, 0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Menu/Root.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import { getKey } from '../utils/uid';
import normalizeWheel from '../utils/dom/normalizeWheel';
import ScrollBar from '../Scroll/Bar';
import { menuClass } from './styles';
import List from './List';
import { Provider } from './context';
import { isArray } from '../utils/is';
import { isRTL } from '../config';
import { Component } from '../component';
export var DefaultProps = (cov_1nuphi3xlt.s[0]++, {
  data: [],
  level: 0,
  keygen: 'id',
  mode: 'inline',
  inlineIndent: 24,
  renderItem: 'title',
  defaultOpenKeys: [],
  onClick: function onClick() {
    cov_1nuphi3xlt.f[0]++;
    cov_1nuphi3xlt.s[1]++;
    return true;
  },
  toggleDuration: 200,
  frontCaretType: 'solid',
  style: {},
  disabled: function (_disabled) {
    function disabled(_x) {
      return _disabled.apply(this, arguments);
    }

    disabled.toString = function () {
      return _disabled.toString();
    };

    return disabled;
  }(function (d) {
    cov_1nuphi3xlt.f[1]++;
    cov_1nuphi3xlt.s[2]++;
    return d.disabled;
  })
});
var modeDirection = (cov_1nuphi3xlt.s[3]++, {
  'vertical-auto': 'y',
  vertical: 'y',
  horizontal: 'x'
});
cov_1nuphi3xlt.s[4]++;

var getOption = function getOption(mode) {
  cov_1nuphi3xlt.f[2]++;
  cov_1nuphi3xlt.s[5]++;
  return mode.indexOf('vertical') === 0 ? (cov_1nuphi3xlt.b[0][0]++, {
    key: 'height',
    pos: 'Top',
    direction: 'Y'
  }) : (cov_1nuphi3xlt.b[0][1]++, {
    key: 'width',
    pos: 'Left',
    direction: 'X'
  });
};

function keyToMap() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1nuphi3xlt.b[1][0]++, []);
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1nuphi3xlt.b[2][0]++, true);
  cov_1nuphi3xlt.f[3]++;
  var keyMap = (cov_1nuphi3xlt.s[6]++, new Map());
  cov_1nuphi3xlt.s[7]++;
  keys.forEach(function (v) {
    cov_1nuphi3xlt.f[4]++;
    cov_1nuphi3xlt.s[8]++;
    keyMap.set(v, value);
  });
  cov_1nuphi3xlt.s[9]++;
  return keyMap;
} // function isSubMenu(el) {
//   if (el.matches(`.${menuClass('sub')}`)) return true
//   if (!el.parentElement) return false
//   return isSubMenu(el.parentElement)
// }


var Root =
/*#__PURE__*/
function (_Component) {
  _inherits(Root, _Component);

  var _super = _createSuper2(Root);

  function Root(props) {
    var _this;

    _classCallCheck(this, Root);

    cov_1nuphi3xlt.f[5]++;
    cov_1nuphi3xlt.s[10]++;
    _this = _super.call(this, props);
    _this.handleScrollLeft = void 0;
    _this.handleScrollTop = void 0;
    _this.items = void 0;
    _this.itemsOpen = void 0;
    _this.itemsInPath = void 0;
    _this.providerValue = void 0;
    _this.container = void 0;
    _this.hasToggled = void 0;
    _this.wrapper = void 0;
    _this.rootElement = void 0;
    cov_1nuphi3xlt.s[11]++;
    _this.state = {
      activeKey: null,
      scrollTop: 0,
      scrollLeft: 0,
      openKeys: keyToMap(props.defaultOpenKeys)
    };
    cov_1nuphi3xlt.s[12]++;
    _this.checkOpen = _this.checkOpen.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[13]++;
    _this.checkActive = _this.checkActive.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[14]++;
    _this.checkInPath = _this.checkInPath.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[15]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[16]++;
    _this.handleScrollLeft = _this.handleScrollX.bind(_assertThisInitialized(_this), 'Left');
    cov_1nuphi3xlt.s[17]++;
    _this.handleScrollTop = _this.handleScrollX.bind(_assertThisInitialized(_this), 'Top');
    cov_1nuphi3xlt.s[18]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[19]++;
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[20]++;
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[21]++;
    _this.bindRootElement = _this.bindRootElement.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[22]++;
    _this.toggleOpenKeys = _this.toggleOpenKeys.bind(_assertThisInitialized(_this));
    cov_1nuphi3xlt.s[23]++;
    _this.providerValue = {
      bindItem: _this.bindItem.bind(_assertThisInitialized(_this)),
      unbindItem: _this.unbindItem.bind(_assertThisInitialized(_this))
    };
    cov_1nuphi3xlt.s[24]++;
    _this.items = {};
    cov_1nuphi3xlt.s[25]++;
    _this.itemsOpen = {};
    cov_1nuphi3xlt.s[26]++;
    _this.itemsInPath = {};
    return _this;
  }

  _createClass(Root, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1nuphi3xlt.f[6]++;
      cov_1nuphi3xlt.s[27]++;

      _get(_getPrototypeOf(Root.prototype), "componentDidMount", this).call(this);

      cov_1nuphi3xlt.s[28]++;
      this.updateState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      cov_1nuphi3xlt.f[7]++;
      cov_1nuphi3xlt.s[29]++;
      this.updateState();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1nuphi3xlt.f[8]++;
      cov_1nuphi3xlt.s[30]++;
      this.container.removeEventListener('wheel', this.handleWheel);
      cov_1nuphi3xlt.s[31]++;

      _get(_getPrototypeOf(Root.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getOpenKeys",
    value: function getOpenKeys() {
      cov_1nuphi3xlt.f[9]++;

      var _ref = (cov_1nuphi3xlt.s[32]++, this.props),
          openKeys = _ref.openKeys,
          defaultOpenKeys = _ref.defaultOpenKeys;

      cov_1nuphi3xlt.s[33]++;

      if (openKeys) {
        cov_1nuphi3xlt.b[3][0]++;
        cov_1nuphi3xlt.s[34]++;
        return openKeys;
      } else {
        cov_1nuphi3xlt.b[3][1]++;
      }

      cov_1nuphi3xlt.s[35]++;
      return this.hasToggled ? (cov_1nuphi3xlt.b[4][0]++, Array.from(this.state.openKeys.keys())) : (cov_1nuphi3xlt.b[4][1]++, defaultOpenKeys);
    }
  }, {
    key: "bindRootElement",
    value: function bindRootElement(el) {
      cov_1nuphi3xlt.f[10]++;
      cov_1nuphi3xlt.s[36]++;
      this.container = el;
      cov_1nuphi3xlt.s[37]++;

      if (!el) {
        cov_1nuphi3xlt.b[5][0]++;
        cov_1nuphi3xlt.s[38]++;
        return;
      } else {
        cov_1nuphi3xlt.b[5][1]++;
      }

      cov_1nuphi3xlt.s[39]++;
      this.wrapper = el.querySelector(".".concat(menuClass('wrapper')));
      cov_1nuphi3xlt.s[40]++;
      this.rootElement = el.querySelector(".".concat(menuClass('root')));
    }
  }, {
    key: "bindItem",
    value: function bindItem(id, updateActive, updateOpen, updateInPath) {
      cov_1nuphi3xlt.f[11]++;
      cov_1nuphi3xlt.s[41]++;
      this.items[id] = updateActive;
      cov_1nuphi3xlt.s[42]++;
      this.itemsOpen[id] = updateOpen;
      cov_1nuphi3xlt.s[43]++;
      this.itemsInPath[id] = updateInPath;
      cov_1nuphi3xlt.s[44]++;
      return [this.checkActive, this.checkOpen, this.checkInPath];
    }
  }, {
    key: "unbindItem",
    value: function unbindItem(id) {
      cov_1nuphi3xlt.f[12]++;
      cov_1nuphi3xlt.s[45]++;
      delete this.items[id];
      cov_1nuphi3xlt.s[46]++;
      delete this.itemsOpen[id];
      cov_1nuphi3xlt.s[47]++;
      delete this.itemsInPath[id];
    }
  }, {
    key: "checkActive",
    value: function checkActive(id, data) {
      cov_1nuphi3xlt.f[13]++;

      var _ref2 = (cov_1nuphi3xlt.s[48]++, this.props),
          active = _ref2.active;

      var act = (cov_1nuphi3xlt.s[49]++, typeof active === 'function' ? (cov_1nuphi3xlt.b[6][0]++, active(data)) : (cov_1nuphi3xlt.b[6][1]++, id === this.state.activeKey)); // @ts-ignore 历史原因，待优化

      cov_1nuphi3xlt.s[50]++;

      if (act) {
        cov_1nuphi3xlt.b[7][0]++;
        cov_1nuphi3xlt.s[51]++;
        this.state.activeKey = id;
      } else {
        cov_1nuphi3xlt.b[7][1]++;
      }

      cov_1nuphi3xlt.s[52]++;

      if ((cov_1nuphi3xlt.b[9][0]++, !act) && (cov_1nuphi3xlt.b[9][1]++, this.state.activeKey === id)) {
        cov_1nuphi3xlt.b[8][0]++;
        cov_1nuphi3xlt.s[53]++;
        // @ts-ignore 历史原因，待优化
        this.state.activeKey = '';
      } else {
        cov_1nuphi3xlt.b[8][1]++;
      }

      cov_1nuphi3xlt.s[54]++;
      return act;
    }
  }, {
    key: "checkOpen",
    value: function checkOpen(id) {
      cov_1nuphi3xlt.f[14]++;
      var openKeys = (cov_1nuphi3xlt.s[55]++, this.getOpenKeys());
      cov_1nuphi3xlt.s[56]++;

      if (isArray(openKeys)) {
        cov_1nuphi3xlt.b[10][0]++;
        cov_1nuphi3xlt.s[57]++;
        return openKeys.indexOf(id) > -1;
      } else {
        cov_1nuphi3xlt.b[10][1]++;
      }

      cov_1nuphi3xlt.s[58]++;
      return false;
    }
  }, {
    key: "checkInPath",
    value: function checkInPath(id) {
      cov_1nuphi3xlt.f[15]++;

      var _ref3 = (cov_1nuphi3xlt.s[59]++, this.state),
          activeKey = _ref3.activeKey;

      cov_1nuphi3xlt.s[60]++;

      if ((cov_1nuphi3xlt.b[12][0]++, !activeKey) || (cov_1nuphi3xlt.b[12][1]++, !id)) {
        cov_1nuphi3xlt.b[11][0]++;
        cov_1nuphi3xlt.s[61]++;
        return false;
      } else {
        cov_1nuphi3xlt.b[11][1]++;
      }

      cov_1nuphi3xlt.s[62]++;
      return activeKey.indexOf(id) >= 0;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      cov_1nuphi3xlt.f[16]++;

      var _ref4 = (cov_1nuphi3xlt.s[63]++, this.props),
          mode = _ref4.mode;

      cov_1nuphi3xlt.s[64]++;
      this.updateActive();
      cov_1nuphi3xlt.s[65]++;
      this.updateOpen();
      cov_1nuphi3xlt.s[66]++;
      this.updateInPath();
      cov_1nuphi3xlt.s[67]++;

      if (!this.container) {
        cov_1nuphi3xlt.b[13][0]++;
        cov_1nuphi3xlt.s[68]++;
        return;
      } else {
        cov_1nuphi3xlt.b[13][1]++;
      }

      var bindMethod = (cov_1nuphi3xlt.s[69]++, mode !== 'inline' ? (cov_1nuphi3xlt.b[14][0]++, this.container.addEventListener) : (cov_1nuphi3xlt.b[14][1]++, this.container.removeEventListener));
      cov_1nuphi3xlt.s[70]++;
      bindMethod.call(this.container, 'wheel', this.handleWheel, {
        passive: false
      });
    }
  }, {
    key: "updateActive",
    value: function updateActive() {
      var _this2 = this;

      cov_1nuphi3xlt.f[17]++;
      cov_1nuphi3xlt.s[71]++;
      Object.keys(this.items).forEach(function (id) {
        cov_1nuphi3xlt.f[18]++;
        var update = (cov_1nuphi3xlt.s[72]++, _this2.items[id]);
        cov_1nuphi3xlt.s[73]++;
        update(_this2.checkActive, _this2.state.activeKey);
      });
    }
  }, {
    key: "updateOpen",
    value: function updateOpen() {
      var _this3 = this;

      cov_1nuphi3xlt.f[19]++;

      var _ref5 = (cov_1nuphi3xlt.s[74]++, this.props),
          data = _ref5.data,
          keygen = _ref5.keygen;

      cov_1nuphi3xlt.s[75]++;
      Object.keys(this.itemsOpen).forEach(function (id) {
        cov_1nuphi3xlt.f[20]++;
        var update = (cov_1nuphi3xlt.s[76]++, _this3.itemsOpen[id]);
        cov_1nuphi3xlt.s[77]++;
        update(_this3.checkOpen);
      });
      var hasOpen = (cov_1nuphi3xlt.s[78]++, this.getOpenKeys().filter(function (k) {
        cov_1nuphi3xlt.f[21]++;
        cov_1nuphi3xlt.s[79]++;
        return data.find(function (d, i) {
          cov_1nuphi3xlt.f[22]++;
          cov_1nuphi3xlt.s[80]++;
          return getKey(d, keygen, i) === k;
        });
      }).length > 0);
      cov_1nuphi3xlt.s[81]++;

      if (hasOpen !== this.state.hasOpen) {
        cov_1nuphi3xlt.b[15][0]++;
        cov_1nuphi3xlt.s[82]++;
        this.setState({
          hasOpen: hasOpen
        });
      } else {
        cov_1nuphi3xlt.b[15][1]++;
      }
    }
  }, {
    key: "updateInPath",
    value: function updateInPath() {
      var _this4 = this;

      cov_1nuphi3xlt.f[23]++;
      cov_1nuphi3xlt.s[83]++;
      Object.keys(this.itemsInPath).forEach(function (id) {
        cov_1nuphi3xlt.f[24]++;
        var update = (cov_1nuphi3xlt.s[84]++, _this4.itemsInPath[id]);
        cov_1nuphi3xlt.s[85]++;
        update(_this4.checkInPath);
      });
    }
  }, {
    key: "toggleOpenKeys",
    value: function toggleOpenKeys(id, open) {
      cov_1nuphi3xlt.f[25]++;
      var newOpenKeys = (cov_1nuphi3xlt.s[86]++, immer(keyToMap(this.getOpenKeys()), function (draft) {
        cov_1nuphi3xlt.f[26]++;
        cov_1nuphi3xlt.s[87]++;

        if (open) {
          cov_1nuphi3xlt.b[16][0]++;
          cov_1nuphi3xlt.s[88]++;
          draft.set(id, true);
        } else {
          cov_1nuphi3xlt.b[16][1]++;
          cov_1nuphi3xlt.s[89]++;
          draft["delete"](id);
        }
      }));
      cov_1nuphi3xlt.s[90]++;
      this.hasToggled = true;
      var keys = (cov_1nuphi3xlt.s[91]++, Array.from(newOpenKeys.keys()));

      var _ref6 = (cov_1nuphi3xlt.s[92]++, this.props),
          _ref6$onOpenChange = _ref6.onOpenChange,
          onOpenChange = _ref6$onOpenChange === void 0 ? (cov_1nuphi3xlt.b[17][0]++, function () {
        cov_1nuphi3xlt.f[27]++;
      }) : _ref6$onOpenChange,
          openKeys = _ref6.openKeys;

      cov_1nuphi3xlt.s[93]++;

      if (openKeys) {
        cov_1nuphi3xlt.b[18][0]++;
        cov_1nuphi3xlt.s[94]++;
        onOpenChange(keys);
        cov_1nuphi3xlt.s[95]++;
        return;
      } else {
        cov_1nuphi3xlt.b[18][1]++;
      }

      cov_1nuphi3xlt.s[96]++;
      this.setState({
        openKeys: newOpenKeys,
        hasOpen: keys.length > 0
      });
      cov_1nuphi3xlt.s[97]++;
      onOpenChange(keys);
    }
  }, {
    key: "handleScrollX",
    value: function handleScrollX(pos, param) {
      cov_1nuphi3xlt.f[28]++;
      var sizeKey = (cov_1nuphi3xlt.s[98]++, pos === 'Top' ? (cov_1nuphi3xlt.b[19][0]++, 'height') : (cov_1nuphi3xlt.b[19][1]++, 'width'));
      var size = (cov_1nuphi3xlt.s[99]++, this.container.getBoundingClientRect()[sizeKey]);
      var scroll = (cov_1nuphi3xlt.s[100]++, this.rootElement.getBoundingClientRect()[sizeKey]);
      cov_1nuphi3xlt.s[101]++;
      this.wrapper["scroll".concat(pos)] = param * (scroll - size);
      cov_1nuphi3xlt.s[102]++;
      this.setState(_defineProperty({}, "scroll".concat(pos), param));
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(top) {
      cov_1nuphi3xlt.f[29]++;

      var _ref7 = (cov_1nuphi3xlt.s[103]++, this.container.getBoundingClientRect()),
          height = _ref7.height;

      var scrollHeight = (cov_1nuphi3xlt.s[104]++, this.rootElement.getBoundingClientRect().height);
      cov_1nuphi3xlt.s[105]++;
      this.wrapper.scrollTop = top * (scrollHeight - height);
      cov_1nuphi3xlt.s[106]++;
      this.setState({
        scrollTop: top
      });
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(e) {
      cov_1nuphi3xlt.f[30]++;

      // if (isSubMenu(e.target)) return
      var _ref8 = (cov_1nuphi3xlt.s[107]++, this.props),
          mode = _ref8.mode;

      var _ref9 = (cov_1nuphi3xlt.s[108]++, getOption(mode)),
          key = _ref9.key,
          pos = _ref9.pos,
          direction = _ref9.direction;

      var wheel = (cov_1nuphi3xlt.s[109]++, normalizeWheel(e));
      var size = (cov_1nuphi3xlt.s[110]++, this.container.getBoundingClientRect()[key]); // const size = this.rootElement.getBoundingClientRect()[key] - this.container.getBoundingClientRect()[key]

      cov_1nuphi3xlt.s[111]++;
      this.wrapper["scroll".concat(pos)] += wheel["pixel".concat(direction)];
      var precent = (cov_1nuphi3xlt.s[112]++, this.wrapper["scroll".concat(pos)] / size);
      cov_1nuphi3xlt.s[113]++;
      this.setState(_defineProperty({}, "scroll".concat(pos), precent > 1 ? (cov_1nuphi3xlt.b[20][0]++, 1) : (cov_1nuphi3xlt.b[20][1]++, precent))); // this.setState({ [`scroll${pos}`]: size === 0 ? 0 : this.wrapper[`scroll${pos}`] / size })

      cov_1nuphi3xlt.s[114]++;
      e.preventDefault();
    }
  }, {
    key: "handleClick",
    value: function handleClick(id, data) {
      cov_1nuphi3xlt.f[31]++;

      var _ref10 = (cov_1nuphi3xlt.s[115]++, this.props),
          onClick = _ref10.onClick;

      cov_1nuphi3xlt.s[116]++;
      this.setState({
        activeKey: id
      });
      cov_1nuphi3xlt.s[117]++;

      if (onClick) {
        cov_1nuphi3xlt.b[21][0]++;
        cov_1nuphi3xlt.s[118]++;
        onClick(data);
      } else {
        cov_1nuphi3xlt.b[21][1]++;
      }
    }
  }, {
    key: "renderItem",
    value: function renderItem(data, index) {
      cov_1nuphi3xlt.f[32]++;

      var _ref11 = (cov_1nuphi3xlt.s[119]++, this.props),
          renderItem = _ref11.renderItem;

      cov_1nuphi3xlt.s[120]++;

      if (typeof renderItem === 'string') {
        cov_1nuphi3xlt.b[22][0]++;
        cov_1nuphi3xlt.s[121]++;
        return data[renderItem];
      } else {
        cov_1nuphi3xlt.b[22][1]++;
      }

      cov_1nuphi3xlt.s[122]++;

      if (typeof renderItem === 'function') {
        cov_1nuphi3xlt.b[23][0]++;
        cov_1nuphi3xlt.s[123]++;
        return renderItem(data, index);
      } else {
        cov_1nuphi3xlt.b[23][1]++;
      }

      cov_1nuphi3xlt.s[124]++;
      return null;
    }
  }, {
    key: "renderScrollBar",
    value: function renderScrollBar() {
      cov_1nuphi3xlt.f[33]++;
      cov_1nuphi3xlt.s[125]++;

      if ((cov_1nuphi3xlt.b[25][0]++, !this.rootElement) || (cov_1nuphi3xlt.b[25][1]++, !this.container)) {
        cov_1nuphi3xlt.b[24][0]++;
        cov_1nuphi3xlt.s[126]++;
        return null;
      } else {
        cov_1nuphi3xlt.b[24][1]++;
      }

      var _ref12 = (cov_1nuphi3xlt.s[127]++, this.props),
          mode = _ref12.mode;

      var direction = (cov_1nuphi3xlt.s[128]++, modeDirection[mode]);
      cov_1nuphi3xlt.s[129]++;

      if (!direction) {
        cov_1nuphi3xlt.b[26][0]++;
        cov_1nuphi3xlt.s[130]++;
        return null;
      } else {
        cov_1nuphi3xlt.b[26][1]++;
      }

      cov_1nuphi3xlt.s[131]++;

      if (direction === 'x') {
        cov_1nuphi3xlt.b[27][0]++;

        var _ref13 = (cov_1nuphi3xlt.s[132]++, this.container.getBoundingClientRect()),
            width = _ref13.width;

        var scrollWidth = (cov_1nuphi3xlt.s[133]++, this.rootElement.getBoundingClientRect().width);
        cov_1nuphi3xlt.s[134]++;

        if (scrollWidth <= width) {
          cov_1nuphi3xlt.b[28][0]++;
          cov_1nuphi3xlt.s[135]++;
          return null;
        } else {
          cov_1nuphi3xlt.b[28][1]++;
        }

        cov_1nuphi3xlt.s[136]++;
        return (
          /*#__PURE__*/
          React.createElement(ScrollBar, {
            className: menuClass('bar'),
            length: width,
            scrollLength: scrollWidth,
            offset: this.state.scrollLeft,
            onScroll: this.handleScrollLeft,
            direction: "x",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 330,
              columnNumber: 9
            }
          })
        );
      } else {
        cov_1nuphi3xlt.b[27][1]++;
      }

      var length = (cov_1nuphi3xlt.s[137]++, this.container.getBoundingClientRect().height);
      var scrollHeight = (cov_1nuphi3xlt.s[138]++, this.rootElement.getBoundingClientRect().height);
      cov_1nuphi3xlt.s[139]++;

      if (scrollHeight < length) {
        cov_1nuphi3xlt.b[29][0]++;
        cov_1nuphi3xlt.s[140]++;
        return null;
      } else {
        cov_1nuphi3xlt.b[29][1]++;
      }

      cov_1nuphi3xlt.s[141]++;
      return (
        /*#__PURE__*/
        React.createElement(ScrollBar, {
          className: menuClass('bar'),
          forceHeight: length,
          length: length,
          scrollLength: scrollHeight,
          offset: this.state.scrollTop,
          onScroll: this.handleScrollTop,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 346,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1nuphi3xlt.f[34]++;

      var _ref14 = (cov_1nuphi3xlt.s[142]++, this.props),
          _ref14$data = _ref14.data,
          data = _ref14$data === void 0 ? (cov_1nuphi3xlt.b[30][0]++, DefaultProps.data) : _ref14$data,
          mode = _ref14.mode,
          style = _ref14.style,
          theme = _ref14.theme,
          height = _ref14.height,
          keygen = _ref14.keygen,
          linkKey = _ref14.linkKey,
          disabled = _ref14.disabled,
          caretColor = _ref14.caretColor,
          frontCaret = _ref14.frontCaret,
          inlineIndent = _ref14.inlineIndent,
          looseChildren = _ref14.looseChildren,
          frontCaretType = _ref14.frontCaretType,
          toggleDuration = _ref14.toggleDuration,
          parentSelectable = _ref14.parentSelectable;

      var isVertical = (cov_1nuphi3xlt.s[143]++, mode.indexOf('vertical') === 0);
      var showScroll = (cov_1nuphi3xlt.s[144]++, ((cov_1nuphi3xlt.b[31][0]++, style) && (cov_1nuphi3xlt.b[31][1]++, style.height) || (cov_1nuphi3xlt.b[31][2]++, height)) && (cov_1nuphi3xlt.b[31][3]++, isVertical) || (cov_1nuphi3xlt.b[31][4]++, mode === 'horizontal'));
      var rtl = (cov_1nuphi3xlt.s[145]++, isRTL());
      var className = (cov_1nuphi3xlt.s[146]++, classnames(menuClass('_', isVertical ? (cov_1nuphi3xlt.b[32][0]++, 'vertical') : (cov_1nuphi3xlt.b[32][1]++, mode), (cov_1nuphi3xlt.b[33][0]++, theme === 'dark') && (cov_1nuphi3xlt.b[33][1]++, 'dark'), (cov_1nuphi3xlt.b[34][0]++, showScroll) && (cov_1nuphi3xlt.b[34][1]++, 'scroll'), (cov_1nuphi3xlt.b[35][0]++, this.state.hasOpen) && (cov_1nuphi3xlt.b[35][1]++, 'has-open'), (cov_1nuphi3xlt.b[36][0]++, rtl) && (cov_1nuphi3xlt.b[36][1]++, 'rtl')), this.props.className));
      var rootStyle = (cov_1nuphi3xlt.s[147]++, {});
      cov_1nuphi3xlt.s[148]++;

      if ((cov_1nuphi3xlt.b[38][0]++, style) && (cov_1nuphi3xlt.b[38][1]++, style.width) && (cov_1nuphi3xlt.b[38][2]++, mode !== 'horizontal')) {
        cov_1nuphi3xlt.b[37][0]++;
        cov_1nuphi3xlt.s[149]++;
        rootStyle.width = style.width;
      } else {
        cov_1nuphi3xlt.b[37][1]++;
      }

      var bottomLine = (cov_1nuphi3xlt.s[150]++, 0);
      var topLine = (cov_1nuphi3xlt.s[151]++, 0);
      cov_1nuphi3xlt.s[152]++;

      if (this.container) {
        cov_1nuphi3xlt.b[39][0]++;
        var rect = (cov_1nuphi3xlt.s[153]++, this.container.getBoundingClientRect());
        cov_1nuphi3xlt.s[154]++;
        bottomLine = rect.bottom;
        cov_1nuphi3xlt.s[155]++;
        topLine = rect.top;
      } else {
        cov_1nuphi3xlt.b[39][1]++;
      }

      var outStyle = (cov_1nuphi3xlt.s[156]++, _objectSpread2({}, style));
      cov_1nuphi3xlt.s[157]++;

      if (height !== undefined) {
        cov_1nuphi3xlt.b[40][0]++;
        cov_1nuphi3xlt.s[158]++;
        outStyle.height = height;
      } else {
        cov_1nuphi3xlt.b[40][1]++;
      }

      cov_1nuphi3xlt.s[159]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          ref: this.bindRootElement,
          style: outStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 407,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: menuClass('wrapper'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 408,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: this.providerValue,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 409,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(List, {
          path: "",
          level: 0,
          mode: mode,
          data: data,
          keygen: keygen,
          style: rootStyle,
          topLine: topLine,
          linkKey: linkKey,
          disabled: disabled,
          frontCaret: frontCaret,
          bottomLine: bottomLine,
          caretColor: caretColor,
          onClick: this.handleClick,
          inlineIndent: inlineIndent,
          renderItem: this.renderItem,
          className: menuClass('root'),
          looseChildren: looseChildren,
          frontCaretType: frontCaretType,
          toggleDuration: toggleDuration,
          parentSelectable: parentSelectable,
          toggleOpenKeys: this.toggleOpenKeys,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 410,
            columnNumber: 13
          }
        }))), (cov_1nuphi3xlt.b[41][0]++, showScroll) && (cov_1nuphi3xlt.b[41][1]++, this.renderScrollBar()))
      );
    }
  }]);

  return Root;
}(Component);

Root.defaultProps = DefaultProps;
Root.displayName = void 0;
export default Root;